module.exports = __webpack_public_path__ + "media/images/sponsorpulse-logo-a173e5ca.png";